// extracted by mini-css-extract-plugin
module.exports = {"main_layout":"layouts_main_layout__27Xsk","facet_headers":"layouts_facet_headers__QRODP"};